import { environment } from "../../config/environment";
import { customFetch } from "../../utils/Auth";

const sentryUrl = (patientId) =>
  `${environment.apiUrl}/support/patients/${encodeURIComponent(patientId)}/sentry`;

/**
 * The visit's Sentry logs (Diagnose fetches the replays itself):
 * { window, environment, logs, truncated, errors }.
 */
export async function getPatientSentry(patientId, { start, end, signal } = {}) {
  const params = new URLSearchParams();
  if (start && end) {
    params.set("start", start);
    params.set("end", end);
  }
  const query = params.toString();
  try {
    const response = await customFetch(`${sentryUrl(patientId)}${query ? `?${query}` : ""}`, {
      method: "GET",
      signal,
    });
    const data = await response.json().catch(() => null);
    if (!response.ok || !data?.success) {
      return { error: data?.error || "Failed to load Sentry activity" };
    }
    return data;
  } catch (err) {
    if (err?.name === "AbortError") return { aborted: true };
    return { error: "Failed to load Sentry activity" };
  }
}

/** Whether the provider started a recording on this patient: { result, problems, window, generated_at }. */
export async function diagnosePatientSentry(patientId, { start, end, signal } = {}) {
  try {
    const response = await customFetch(`${sentryUrl(patientId)}/diagnose`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ start: start || undefined, end: end || undefined }),
      signal,
    });
    const data = await response.json().catch(() => null);
    if (!response.ok || !data?.success) {
      return { error: data?.error || "Diagnosis failed" };
    }
    return data;
  } catch (err) {
    if (err?.name === "AbortError") return { aborted: true };
    return { error: "Diagnosis failed" };
  }
}
